import { HTMLAttributes } from "react";
import cn from "classnames";

/** Small uppercase blue eyebrow above a heading ("Core Feature", "New on iPhone"). */
export default function SectionLabel({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      className={cn(
        "font-display text-[13px] font-semibold uppercase tracking-[0.08em] text-blue-500 dark:text-blue-300",
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
}
